/* ============
 * Organizations Mutations
 * ============
 *
 * The mutations available for the organizations module.
 */

import {
  ALL,
  SET_CURRENT_PAGE,
  SET_ALL,
} from './mutation-types';

export default {
  /**
   * Mutation to update the store with the fetched organizations.
   *
   * @param {Object} state      The current state of the store.
   * @param {Array}  organizations     The fetched organizations.
   * @param {Object} pagination The fetched pagination.
   */
  [ALL](state, { organizations, pagination }) {
    state.all = organizations;
    Object.keys(pagination).forEach((key) => {
      state.pagination[key] = pagination[key];
    });
  },
  [SET_ALL](state, organizations) {
    state.all = organizations;
  },
  [SET_CURRENT_PAGE](state, currentPage) {
    state.pagination.currentPage = currentPage;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/mutations.js